import React from 'react';
import { BoxProps } from '@apia/theme';
import { rtDebug } from '.';
import { responsiveTableActions } from '../../../../store/responsiveTableSlice';
import makeKeyHandler from '../../../../store/selection/makeKeyHandler';
import { useResponsiveTableContext } from './ResponsiveTableContext';
import useRenderDebug from '../../../../hooks/useRenderDebug';

export interface IKeyHandler {
  children: React.ReactNode;
}

const KeyHandler = (props: BoxProps) => {
  const { name, onChangeSelection, onSelectRows } = useResponsiveTableContext();

  const Handler = React.useMemo(
    () =>
      makeKeyHandler(responsiveTableActions, name, {
        throttleOptions: { wait: 50 },
        stateSelector: (global) => global.responsiveTableSlice[name],
      }),
    [name],
  );

  useRenderDebug(rtDebug.keyHandler, 'responsiveTable/KeyHandler.tsx', {
    name,
    onChangeSelection,
    onSelectRows,
    ...props,
    Handler,
  });

  return (
    <Handler
      onChangeSelection={onChangeSelection}
      onSelectRows={onSelectRows}
      {...props}
    />
  );
};

export default React.memo(KeyHandler);
